export enum TimeType {
	None = 0,
	Minutes = 1,
	Hours = 2,
	Days = 3,
	Weeks = 4,
	Months = 5,
}
